export default {
  ShowTransfer: 1,
  ShowCAReceipt: 2,
  Save: 2,
  SaveAdd: 3,
  SaveClose: 4,
  //Hoãn
  Postpone: 5,
  NextVoucher: 6,
  BackVoucher: 7,
  SaveView: 8,
  Ok: 9,
  Delete: 10,
  All: 11,
  Follow: 12,
  Unfollow: 13,
  Active: 14,
  Unactive: 15,
  Edit: 16,
  Duplicate: 17,
  Add: 18,
  Approve: 19,
  Reject: 20,
  View: 21,
  Posted: 22,
  UnPosted: 23,
  Estimate: 24,
  NextStep: 25,
  BackStep: 26,
  ViewAccount: 27,
  ViewQuantity: 28,
  AddAutoBusiness: 29,
  GenerateData: 30,
  GenerateCaPaymentSalary: 31,
  Refresh: 32,
  Copy: 34,
  ShowWithDrawCash: 35,
  ShowWithDrawDeposit: 36,
  ShowWithDrawTransfer: 37,
  ShowWithDrawSalaryTransfer: 38,
  ShowBUTreasuryFundTransferSalary: 39,
  ShowBUTreasuryFundTransferInsurancePayment: 40,
  GLVoucherDetail: 41,
  SaveParalell: 42,
  InsertRowGrid: 43,
  DeleteRowGrid: 44,
  PostponeParalell: 45,
  Cancel: 46,
  SettingAccount: 47,
  //Gửi phê duyệt
  SendApproval: 48,
  Quit: 49,

  //Bảng kê
  BUVoucherListPlanned: 50,
  BUVoucherListNotPlanned: 51,
  BUVoucherListReceipExpense: 52,
  BUVoucherListRealExpense: 53,
  BUVoucherListOther: 54,

  //Sinh các loại giấy rút
  GenerateBUPlanWithdrawTransferDetail: 55, // Giấy rút dự toán tiền mặt
  GenerateBUPlanWithdrawDepositDetail: 56, // Giấy rút dự toán tiền gửi
  GenerateCAReceiptWithdrawDetail: 57,
  //In chứng từ
  Print_C213_TT772017_ST: 58,

  //Hóa đơn
  CreateSaleVoucher: 59,
  ReleaseInvoice: 60,
  CancelInvoice: 61,
  SendInvoice: 62,
  SendNotify: 63,
  CreateSaleVoucherMulti: 64,
  CreateAdjustSaleInvoice: 65, // Lập hóa đơn điều chỉnh vqphong - 22.09.2022
  SaleInvoiceReplace: 66, //Lập hóa đơn thay thế
  DownloadInvoice: 67, // Tải hóa đơn
  ConvertToPaperVoucher: 68, // Chuyển thành hóa đơn giấy
  GenerateInvoice: 69, //Lập hóa đơn
  PublishInvoiceMulti: 70,
  PublishInvoice: 71,

  // Nhập số dư
  AccountBalance: 72,
  // Đóng thuế
  PayTax: 73,

  //Lương
  SalaryAllocation: 74,
  // sinh chi tiền gửi
  GenerateDrawSalary: 75,
  GenerateDataFundSalary: 76, // sinh hạch toán chi phí lương
  GenerateDataFundInsurance: 77, // sinh hạch toán chi phí bảo hiểm
  InvolveVoucher: 78, // Chứng từ liên quan

  GenerateBaDeposit: 79, // sinh thu tiền gửi
  GenerateCAReceipt: 80, // sinh phiếu thu
  GenerateGLVoucher: 81, // sinh chứng từ nghiệp vụ khác

  ShowBUTransfer: 82, // Thêm chứng từ Chuyển khoản kho bạc
  ShowBUTransferDeposit: 83, // Thêm chứng từ Chuyển khoản kho bạc vào TK tiền gửi
  ShowBAWithDraw: 84, // Thêm chứng từ Chi tiền gửi
  CAPaymentPurchase: 85, // Phiếu chi mua VTHH
  BAWithdrawPurchase: 86, // Chi tiền gửi mua VTHH
  BUTransferPurchase: 87, // Chuyển khoản kho bạc mua VTHH

  ShowCAReceiptSale: 88, // Chuyển khoản Thu tiền mặt
  ShowBADepositSale: 89, // Chuyển khoản Thu tiền gửi

  SysRole: 90, // Phân quyền
  GetReceipt: 91, // Lấy biên lai
  UpdateTaxIntoSalary: 92, // Cập nhật vào bảng lương
  PayRollAllocation: 93, // Phân bổ nguồn
  RecalculationSalary: 94, // Tính lại lương
  GenerateReceiptFixedAsset: 95, // Sinh phiếu thu bán tài sản cố định
  GenerateInvoiceFixedAsset: 96, // Sinh hóa đơn bán tài sản cố định
  CAPaymentFixedAsset: 97, // Thêm chứng từ Mua TSCĐ bẳng tiền mặt
  BAWithDrawFixedAsset: 98, // Thêm chứng từ Mua TSCĐ bẳng tiền gửi
  BUTransferFixedAsset: 99, // Thêm chứng từ Mua TSCĐ qua chuyển khoản kho bạc
  FAPurchaseInvoice: 100, // Thêm chứng từ Mua TSCĐ chưa thanh toán
  CAReceiptFixedAsset: 101, // Thêm chứng từ Bán tài sản cố định thu tiền mặt
  BADepositFixedAsset: 102, // Thêm chứng từ Bán tài sản cố định thu tiền gửi
  Voucher: 103, // Thêm chứng từ Chứng từ nghiệp vụ khác
  ProvisionalTaxInCome: 104, // Thêm chứng từ Tạm tính thuế TNDN
  FinalTaxInComeEnterprise: 105, // Thêm chứng từ Quyết toán thuế TNDN
  BATransferWithdraw: 106, // Thêm chứng từ Tiền chuyển đi
  BATransferDeposit: 107, // Thêm chứng từ Tiền chuyển đến
  CAPaymentVendor: 108, // Phiếu chi trả nhà cung cấp
  BAWithdrawVendor: 109, // Chi tiền gửi trả nhà cung cấp
  BUTransferVendorPayment: 110, // Chuyển khoản kho bạc trả nhà cung cấp
  ShopwCAReceiptCusomterCash: 111, // Chuyển khoản Thu tiền mặt
  ShopwCAReceiptCusomterDeposit: 112, // Chuyển khoản Thu tiền gửi
  generateCAReceipt: 113, // Lập chứng từ Phiếu thu
  generateBADeposit: 114, // Lập chứng từ Thu tiền gửi
  generateGLVoucher: 115, // Lập chứng từ Chứng từ nghiệp vụ khác
  OutwardFromINAdjustment: 116, // Lập phiếu xuất kho
  InwardFromINAdjustment: 117, // Lập phiếu nhập kho
  GenerateBUTransferDeposit: 118, // Sinh chứng từ chuyển khoản kho bạc vào tài khoản tiền gửi
  ShowCAPaymentDetail: 119, // Thêm chứng từ Phiếu chi
  ShowCAPaymentDepositDetail: 120, // Thêm chứng từ Phiếu chi nộp tiền vào NH, KB
  AddInventory: 121, // Thêm vật tư, hàng hóa
  AddTool: 122, // Thêm công cụ, dụng cụ
  SettingAccount: 123, // Thiết lập công thức báo cáo
  ShareReportFormula: 124, //Chia sẻ công thức báo cáo
  ReShareReportFormula: 125, //Chia sẻ tiếp công thức báo cáo được chia sẻ,
  ApplyFormula: 126, //Áp dụng công thức báo cáo được chia sẻ,
  Import: 127, // Nhập khẩu NHANH3 27.07.2023
  IsShowSumSourceKind: 128, // Hiển thị dòng tổng Nguồn NSNN - Khoản
  EditFileDVCReject: 129, // Sửa hồ sơ giao dịch bị KBNN từ chối
  SalaryTemplateManage: 130, // Quản lý mẫu lương
  PrintC203BudgetItemTrue: 131, // in mẫu C203 có tích chọn mỗi mục là 1 báo cáo
  PrintC203BudgetItemFalse: 132, // in mẫu C203 không tích chọn mỗi mục là 1 báo cáo
  PreviewTicket: 133, //Xem vé điện tử
  GetElectronicTicket: 134, //Lấy vé điện tử
  ChooseApprover: 135, //Chọn người duyệt hồ sơ DVC
  IsIncludeAccountNoAraiseTrue: 136, // Hiển thị số dư Tk không phát sinh số liệu
  IsIncludeAccountNoAraiseFalse: 137, // Không hiển thị số dư Tk không phát sinh số liệu
  ConnectDVCMultiBudgetCode: 138, //Đơn vị kết nối DVC Nhiều mã ngân sách

  // Rút dự toán
  BUPlanWithdrawCash: 139,
  // Lưu trữ
  Store: 140,
  // Phục hồi Lưu trữ
  RestoreStore: 141,
  // Thực hiện chức năng tại màn hình Hướng dẫn quyết toán
  ClickButtonInHelpSettlement: 142,
  VoucherSearch: 143, //Tìm kiếm chứng từ
  PayIncomeTax: 144, // Nộp thuế TNCN
  UpdateIntoSalary: 145, // Cập nhật vào bảng lương
  ExportXML: 146, // Xuất XML
  SendEmailReminder: 147, // Gửi email nhắc nợ
  RewriteParagraph: 148, // viết lại văn bản bằng ava
  ViewNewFeature: 149, //Xem tính năng mới
  SearchInfoCompany: 150, // Tra cứu thông tin doanh nghiệp
  GenerateBuTransferMoneyElectric: 151, // Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA (tiền điện)
  GenerateBuTransferMoneyWater: 152, // Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA (tiền nước)
  GenerateBuTransferMoneyPhone: 153, // Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA (tiền điện thoại)
  GenerateBuSalary: 154, // Sinh chứng từ rút dự toán chuyển khoản lương từ MISA AVA
  GenerateBuInsurance: 155, // Sinh chứng từ rút dự toán chuyển khoản thanh toán bảo hiểm từ MISA AVA
  GenerateBuPlanWithDraw: 156, // Sinh chứng từ rút dự toán chuyển khoản từ MISA AVA
  VoiceInputInterpretation: 157, // Nhập liệu diễn giải bằng giọng nói
  EditSampleS11H: 158, // Sửa mẫu sổ S11-H Sổ quỹ tiền mặt
  EditSampleC23HD: 159, // Sửa mẫu sổ C23HD Biên bản kiểm kê vật tư, công cụ, sản phẩm, hàng hóa
  CheckStatusCompany: 160, // Kiểm tra tình trạng doanh nghiệp
  HandleVoucherDifferentFixedAssetWithQLTS: 161, // Xử lý chứng từ hạch toán chênh lệch TSCĐ với phần mềm QLTS
  ViewUserInfo: 162, // Xem thông tin người dùng
  ViewGuideVoucherNewYear: 163, // Xem hướng dẫn nhập chứng từ năm mới
  DeleteVoucherRelationWhenDeleteVoucherRoot: 164, // Xóa chứng từng có liên quan khi thực hiện xóa chứng từ gốc
  SendEmailPaySalary: 165, // Soạn email thông báo trả lương
  AddDescriptionOnC30HD: 166, // Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho
  AddDescriptionOnC30HDTwoParts: 167, // Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho (2 liên)
  AddDescriptionOnC30HDHasTax: 168, // Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho (có thuế)
  ChangeCapitalPlanYear: 169, //Thay đổi Năm kế hoạch vốn trên mẫu C2-05a/NS
  ExportExcel: 170, // Xuất XML
  IsDetailbyBudgetProvidence: 171, // Chi tiết theo mã dự phòng
  ConnectBumas: 172, // Kết nối Bumas
  GetDictionaryFromBumas: 173, // Lấy danh mục từ Bumas
  GetBumasDecision: 174, // Lấy quyết định giao từ Bumas
  SendDataBumas: 175, // Đẩy thông tin tình hình thực hiện dự toán sang Bumas
  EditSample01a: 176, // Sửa mẫu sổ Mẫu số 01a-SDKP/ĐVDT
  EditSample01b: 177, // Sửa mẫu sổ Mẫu số 01b-SDKP/ĐVDT
  EditSample02a: 178, // Sửa mẫu sổ Mẫu số 02a-SDKP/ĐVDT
  EditSample02b: 179, // Sửa mẫu sổ Mẫu số 02b-SDKP/ĐVDT
  ConnectASP: 180, // Kết nối chuyên gia
  ReportSetting: 181, // Tùy chọn in
  EditCoverS61: 182, // Sửa bìa S61
  CreateDvcMS09: 183, // Lập mẫu 09
  ConvertFromOthers: 184, // Tải bộ chuyển đổi từ phần mềm khác
  Restore: 185, // Lấy lại thiết lập mặc định
  CreateTaxReduction1012023QH15: 186, // Lập phụ lục Giảm thuế GTGT theo Nghị quyết 101/2023/QH15
  ExportXmlTaxReduction1012023QH15: 187, // Xuất khẩu XML mẫu phục lục Giảm thuế GTGT theo Nghị quyết 101/2023/QH15
  AddTAEnterpriseIncomeTax: 188, // Thêm mới tờ khai thuế thu nhập doanh nghiệp mẫu 04/TNDN
  PayUnionInsurance: 189, // Nộp bảo hiểm, công đoàn phí
  GenSaleVoucherFromInvoice: 190, // Sinh chứng từ bán hàng từ hóa đơn
  ChangeTaxCalculationMethod: 191, // Thực hiện lại chọn tính thuế GTGT theo phương pháp trực tiếp
  CoverDesign: 192, // Thiết kế bìa sổ
  SelectedStatistic: 193, // Chọn mã thống kê
  OnlyEmployeeOutside: 194, // Chỉ chọn cán  bộ ngoài đơn vị
  IncludeEmployeeOutside: 195, // Bao gồm cả cán bộ ngoài đơn vị,
  Print052KQTTTNCN: 196,
  ExportXML04GTGT: 197, // Lập tờ khai thuế 04-GTGT
  EmployeeOutside: 198, // Là cán bộ ngoài đơn vị
  CreateVoucherWithTaxDirect: 199,
  GenerateAva: 200, // Sinh chứng từ từ Ava
};
